import { motion } from "framer-motion";

const AUTHOR_PHOTO =
  "https://customer-assets.emergentagent.com/job_written-by-logart/artifacts/d86r2c69_Profile%20pic%20black%20and%20white.jpg";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.15, ease: "easeOut" },
  }),
};

export default function AuthorSection() {
  return (
    <section
      id="author"
      data-testid="author-section"
      className="relative py-24 md:py-32"
    >
      <div className="section-separator mb-24 md:mb-32" />

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Photo */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={0}
            className="flex justify-center lg:justify-start"
          >
            <div className="relative img-reveal">
              <div
                className="absolute -inset-4 rounded-sm opacity-20 blur-2xl"
                style={{ background: "rgba(234,208,161,0.1)" }}
              />
              <img
                src={AUTHOR_PHOTO}
                alt="Ulrika Logart — Author"
                data-testid="author-photo"
                className="relative z-10 w-72 md:w-80 lg:w-96 rounded-sm object-cover"
                style={{
                  aspectRatio: "3/4",
                  objectPosition: "center top",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
                  border: "1px solid rgba(234,208,161,0.08)",
                }}
              />
            </div>
          </motion.div>

          {/* Bio */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={1}
          >
            <p
              className="text-sm tracking-widest uppercase mb-4"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 400,
                color: "var(--text-secondary)",
                letterSpacing: "0.15em",
              }}
            >
              The Author
            </p>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl mb-6"
              style={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 400,
                color: "var(--text-primary)",
                lineHeight: 1.2,
              }}
            >
              Ulrika <span style={{ color: "var(--gold)" }}>Logart</span>
            </h2>
            <div className="gold-divider mb-8" />

            <p
              className="text-base md:text-lg leading-relaxed mb-6"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 300,
                color: "var(--text-secondary)",
                lineHeight: 1.85,
              }}
            >
              Self-published Swedish writer, Ulrika released her first children's
              book in 2025. After giving birth to her first child, she got the idea
              of creating the story of The Disco Whale.
            </p>
            <p
              className="text-base md:text-lg leading-relaxed mb-6"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 300,
                color: "var(--text-secondary)",
                lineHeight: 1.85,
              }}
            >
              A creative person with an interest in writing since childhood, Ulrika
              grew up loving the Swedish stories of Bamse — the kind bear who gains
              extra strength from a special honey to help those in need.
            </p>
            <p
              className="text-base md:text-lg leading-relaxed mb-8"
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 300,
                color: "var(--text-secondary)",
                lineHeight: 1.85,
              }}
            >
              Her mission is to contribute to making this world a better place for
              future generations, focusing on stories of{" "}
              <span style={{ color: "var(--gold)", fontWeight: 400 }}>
                empathy, kindness, friendship,
              </span>{" "}
              and exploring the world.
            </p>

            <a
              href="https://www.goodreads.com/author/show/60231573.Ulrika_Logart"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline"
              data-testid="author-goodreads-link"
            >
              View on Goodreads
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
